import { Injectable } from '@angular/core'
import { Title, Meta } from '@angular/platform-browser'
import { metaDataContent } from '../content/meta-data.content'
import { MetaObject } from '../interfaces/meta-object.interface'
import { environment } from '../../../environments/environment'
import { EnvironmentService } from './environment.service'
import { Environment } from '../interfaces/environment.interface'

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  defaultMeta: MetaObject = metaDataContent['defaultMeta']

  metaTitleSuffix = ' | INNOTAX Portal'

  environment: Environment

  constructor(
    private title: Title,
    private meta: Meta,
    private environmentService: EnvironmentService
  ) {
    this.environmentService.loadEnvironment().subscribe((env) => {
      this.environment = env
    })
  }

  setTags(pageName: string): void {
    const meta = metaDataContent[pageName] || this.defaultMeta

    this.title.setTitle(
      meta.title + this.metaTitleSuffix || (this.defaultMeta.title as string)
    )
    this.meta.updateTag({
      name: 'description',
      content: meta.description || (this.defaultMeta.description as string)
    })
  }

  setDynamicTags(pageMeta: MetaObject): void {
    this.title.setTitle(
      pageMeta.title + this.metaTitleSuffix ||
        (this.defaultMeta.title as string)
    )
    this.meta.updateTag({
      name: 'description',
      content: pageMeta.description || (this.defaultMeta.description as string)
    })
    this.meta.updateTag({
      name: 'og:description',
      content: pageMeta.description || (this.defaultMeta.description as string)
    })
    this.meta.updateTag({
      name: 'og:title',
      content: pageMeta.title || (this.defaultMeta.title as string)
    })
    this.meta.updateTag({
      name: 'og:url',
      content: this.environment.baseUrl + pageMeta.path
    })
    this.meta.updateTag({
      name: 'og:image',
      content:
        pageMeta.absoluteOgImage || (this.defaultMeta.absoluteOgImage as string)
    })
  }
}
